import { render } from "./FullscreenAdEditorCmp.vue?vue&type=template&id=2c6fa224"
import script from "./FullscreenAdEditorCmp.vue?vue&type=script&lang=js"
export * from "./FullscreenAdEditorCmp.vue?vue&type=script&lang=js"

import "./FullscreenAdEditorCmp.vue?vue&type=style&index=0&id=2c6fa224&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__